import { configureStore } from '@reduxjs/toolkit';
import exerciseDataReducer from '../features/exerciseDataReducer';
import userReducer, { currentUserId } from '../features/userSlice'; // Corrected import

const store = configureStore({
    reducer: {
        exerciseData: exerciseDataReducer,
        user: userReducer,
        // Add other reducers as needed
    },
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
});

export default store;
